'use strict';

exports.__esModule = true;
exports.putReqToPipeline = exports.cancelAjax = undefined;

var _actionTypes = require('./action-types');

var actions = _interopRequireWildcard(_actionTypes);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var cancelAjax = exports.cancelAjax = function cancelAjax(store) {
  return function (next) {
    return function (action) {
      if (action.type === actions.CANCEL_AJAX) {
        var ajax = store.getState().ajaxRequests.find(function (item) {
          return item.id === action.id;
        });
        ajax.xhr.abort();
      } else {
        next(action);
      }
    };
  };
};

var putReqToPipeline = exports.putReqToPipeline = function putReqToPipeline(store) {
  return function (next) {
    return function (action) {
      var method = action.method;
      var url = action.url;
      var opts = action.opts;

      if (method && url) {
        (0, _utils.putRequest)(method, url, opts);
      } else {
        next(action);
      }
    };
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/ajax/middlewares.js
 ** module id = 116
 ** module chunks = 0
 **/